export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_ACTION_COUNT = 'SET_ACTION_COUNT'
export const SET_ORDER_ERRORS = 'SET_ORDER_ERRORS'
